/**
 * Canonical analysis constants — the one place every magic number lives.
 * Mirrors the `analysis_config` DB row (SPEC.md § Statistics).
 */
export const SCALE_MIN = 1;
export const SCALE_MAX = 5;

/** Quadrant midpoints. highMean = mean >= MEAN_MIDPOINT; highSD = sd > SD_MIDPOINT. */
export const MEAN_MIDPOINT = 3.0;
export const SD_MIDPOINT = 1.0;

/** A question is flagged "High Divergence" when its sd exceeds this. */
export const HIGH_DIVERGENCE_SD = 1.2;

/** Benchmark deltas are only surfaced when |Δ| exceeds this. */
export const BENCHMARK_DELTA_THRESHOLD = 0.2;

/**
 * Below this many respondents a mean is flagged "indicative only" — the number is
 * still computed correctly (blanks are excluded, never imputed), but rests on too
 * few people to read confidently. Purely a presentation cue; never affects the math.
 */
export const MIN_RELIABLE_N = 5;
